import { Fragment } from 'react'
import { Alert, AlertDescription, AlertIcon, Badge, Card, HStack, Stack, Text } from '@chakra-ui/react'

import { Avatar } from 'components'
import { CustomFormAnswer } from 'components/tools/CustomForm/types'
import { capitalizeString, getFormattedAvatarUrl } from 'utils/transforms/string'
import { formatDateAndHourToString } from 'utils/transforms/date'

import { VALIDATE_QUESTION_ANSWER_STATUS_OBJECT } from 'components/tools/CustomForm/constants'

type Props = {
  verification: CustomFormAnswer
}

export default function CustomFormValidateDataAlert({ verification }: Props) {
  const validateAnswerStatus = VALIDATE_QUESTION_ANSWER_STATUS_OBJECT[verification.answer_reviewed_status as string]

  if (!verification.answer_reviewed_at) return null

  return (
    <Fragment>
      <Stack>
        <Badge width="min-content" colorScheme={validateAnswerStatus?.color}>
          {validateAnswerStatus?.name} por
        </Badge>

        <Card p={2} borderWidth="1px" borderColor="borderColor">
          <HStack>
            <Avatar size="md" src={getFormattedAvatarUrl(verification?.answer_reviewed_by, 'reviewed_by_main')} />
            <Stack spacing={1}>
              <Text>{capitalizeString(verification?.answer_reviewed_by?.reviewed_by_name)}</Text>
              <Text variant="secondary">
                {`${validateAnswerStatus?.name} em `}
                {formatDateAndHourToString(verification?.answer_reviewed_at)}
              </Text>
            </Stack>
          </HStack>
        </Card>

        <Alert rounded="md" status={validateAnswerStatus.name === 'Rejeitado' ? 'error' : 'info'}>
          <AlertIcon />
          <AlertDescription>{verification.answer_reviewed_description}</AlertDescription>
        </Alert>
      </Stack>
    </Fragment>
  )
}
